import { getAssistantConversation } from "@/entities/assistant/assistant.api"
import { assistantKeys } from "@/entities/assistant/assistant.queries"
import type { AssistantConversationTranscript } from "@/entities/assistant/assistant.types"
import { queryOptions, type QueryClient } from "@tanstack/react-query"

// Resolve names through the account-authorized resource, including after a reload. Notification
// history still stores IDs only; document names and prompts never enter session storage.
export const completionTaskQuery = (
  conversationId: string,
  queryClient: QueryClient
) =>
  queryOptions({
    // Conversation invalidations must not download every inbox transcript again.
    queryKey: assistantKeys.completionTaskName(conversationId),
    queryFn: async () => {
      const key = assistantKeys.conversation(conversationId)
      const cached =
        queryClient.getQueryState<AssistantConversationTranscript>(key)
      const transcript =
        cached?.data && !cached.isInvalidated
          ? cached.data
          : await getAssistantConversation({ conversationId, quiet: true })
      return completionTaskName(conversationId, transcript)
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

export const completionTaskName = (
  conversationId: string,
  transcript?: AssistantConversationTranscript
) => transcript?.conversation?.title?.trim() || `#${conversationId}`
